"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconsReact = require("@carbon/icons-react");

require("./sass/NavLeft.scss");

var _logoSchola = _interopRequireDefault(require("./assets/logo-schola.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NavLeft = function NavLeft() {
  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleOpening = function handleOpening() {
    setOpen(!open);
  };

  var arrowClass = {
    'arrowDisactive': !open
  };
  var navClass = {
    'navLeftDisactive': !open
  };
  return /*#__PURE__*/_react.default.createElement("aside", {
    className: (0, _classnames.default)('navLeft', navClass)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _logoSchola.default,
    alt: "Shola logo"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "navLeft-logo-text"
  }, open && 'Schola')), /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-group"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Home24, null), open && 'Dashboard')), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Events24, null), open && 'Relationship Manager')), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Crossroads24, null), open && 'Tours')), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Bullhorn24, null), open && 'Campaigns')), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Calculator24, null), open && 'Marketing Calculator')), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Building24, null), open && 'School Setup'))), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-link-item"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.Settings24, null), open && 'Account Settings')), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "navLeft-account"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-account-item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navLeft-account-item-avatar"
  }, "SS"), open && 'sam.smore@charter.org')), /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleOpening,
    className: (0, _classnames.default)('navLeft-arrow', arrowClass),
    "data-testid": "handler"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.ChevronLeft32, {
    fill: "white"
  })));
};

var _default = NavLeft;
exports.default = _default;